import Typography from '@mui/material/Typography';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { Dispatch, SetStateAction } from 'react';
import { buttonSx, textSx } from './styles';

type ViewButtonProps = {
  expanded: boolean;
  setExpanded: Dispatch<SetStateAction<boolean>>;
};

export default function ViewButton({ expanded, setExpanded }: Readonly<ViewButtonProps>) {
  const { t } = useTranslation();

  return (
    <Button onClick={() => setExpanded(!expanded)} data-testid='view-button' sx={buttonSx}>
      <Typography variant='button' sx={textSx}>
        {expanded ? t('admin.centralReportsPage.viewLess') : t('admin.centralReportsPage.viewMore')}
      </Typography>
      {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
    </Button>
  );
}
